import(/* webpackMode: "eager" */ "/codebuild/output/src4213971629/src/doctor-dashboard/src/components/loader/AppLoader.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4213971629/src/doctor-dashboard/src/components/loader/SplashScreenLoader.tsx");
